/**************************************************
 * Nombre:       Formacion_Certifiquese
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import ic_certificado from '../../../Recursos/ic_certificado.svg'
import ic_desarrollo from '../../../Recursos/ic_desarrollo.svg'
import ic_implemento from '../../../Recursos/ic_implemento.svg'
import ic_modalidad from '../../../Recursos/ic_modalidad.svg'
import Tarjeta_Icono from "../../Tarjetas/Tarjeta_Icono";
import foto from '../../../Recursos/Temporales/foto.png'
import recepcion from '../../../Recursos/fondo_recepcion.png'
import {NEGRITA} from "../../../Constantes";
import Boton from "./Subcomponentes/Boton";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Registro from "../../Dialogos/Dialogo_Registro";
import {formatoFecha} from "../../../Utilidades/formatoFecha";
import {useCuentaRegresiva} from "./Subcomponentes/Hooks/useCuentaRegresiva";

const Formacion_Certifiquese = ({item}) => {
    const {sCell, masSM, sTab} = useResponsive()
    const alto = sCell ? 240 : sTab ? 500 : 420
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Registro, titulo: 'Formulario de Registro'})
    const {Reloj} = useCuentaRegresiva({fecha: item.fechaIncio})

    const abrirRegistro = () => {

        abrir(item);
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: 'white',
                            boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.25)'
                        }}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{
                                backgroundColor: 'white',
                                p: !masSM ? 3 : 6,
                            }}
                            spacing={!masSM ? 2 : 0}
                        >

                            {items.map((item, i) => (
                                <Grid container size={{xs: 6, sm: 6, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Icono item={item}/>
                                </Grid>
                            ))}

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 6, md: 6}}
                                sx={{
                                    background: `url(${foto})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'bottom center',
                                    height: alto
                                }}
                            >


                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 6, md: 6}}
                                sx={{
                                    background: `linear-gradient(180deg, rgba(48, 51, 118, 0.85) 0%, rgba(48, 51, 118, 0.85) 100%), url(${recepcion})`,
                                    p: !masSM ? 4 : 6,
                                    color: "#fff",
                                    height: sCell ? 'auto' : alto,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                }}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                    >
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{
                                                fontFamily: NEGRITA,
                                                fontSize: !masSM ? 32 : 42,
                                                lineHeight: 1,
                                                textAlign: sCell ? 'center' : 'left'
                                            }}>
                                                {item.certifiquese}
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Typography sx={{
                                                fontSize: 16,
                                                fontWeight: 300,
                                                textAlign: sCell ? 'center' : 'left'
                                            }}>
                                                {item.para}
                                            </Typography>
                                        </Grid>

                                        <Grid
                                            container
                                            justifyContent={sCell ? 'center' : 'flex-start'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            sx={{mt: 2}}
                                        >

                                            <Typography sx={{fontWeight: 600, pr: 3}}>Iniciamos en:</Typography>

                                            <Typography sx={{fontWeight: 400}}>
                                                <Reloj/>
                                            </Typography>

                                        </Grid>

                                        <Grid
                                            container
                                            justifyContent={sCell ? 'center' : 'flex-start'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            sx={{mt: 1}}
                                        >

                                            <Typography sx={{fontWeight: 600, pr: 3}}>Fecha Inicio:</Typography>

                                            <Typography
                                                sx={{fontWeight: 400}}>{formatoFecha(item.fechaIncio)}</Typography>

                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4}}>
                                            <Typography sx={{fontWeight: 600, fontSize: 18}}>Cupos
                                                limitados</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                                              sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: 2}}>
                                            <Boton
                                                click={abrirRegistro}
                                                texto={'Aplicar Ahora'}/>
                                        </Grid>


                                    </Grid>
                                </Grid>


                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Certifiquese

const items = [
    {
        nombre: 'Certificamos',
        descripcion: 'Conciliadores en Derecho',
        img: ic_certificado

    },
    {
        nombre: 'Certificamos',
        descripcion: 'Habilitades y tecnicas de negociacion',
        img: ic_desarrollo

    },
    {
        nombre: 'Certificamos',
        descripcion: 'Perspectiva de genero y enfoque diferencial',
        img: ic_implemento

    },
    {
        nombre: 'Modalidad',
        descripcion: '100% Virtual',
        img: ic_modalidad

    },
]